module.exports = __webpack_public_path__ + "img/19800.accd42ea.jpg";